import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const ReleasesPage = lazyPage(() => import("../admin/ReleasesPage"), "ReleasesPage");
const AboutReleaseNotesPage = lazyPage(() => import("../about/ReleaseNotesPage"), "AboutReleaseNotesPage");
const ArchitecturePage = lazyPage(() => import("../about/ArchitecturePage"), "ArchitecturePage");
const AiEthicsPage = lazyPage(() => import("../about/AiEthicsPage"), "AiEthicsPage");
const AiPoliciesPage = lazyPage(() => import("../about/AiPoliciesPage"), "AiPoliciesPage");

// About and releases area (release 0.2.0 Step D).
export { AboutReleaseNotesPage, ArchitecturePage, AiEthicsPage, AiPoliciesPage };

export function AdminReleasesPage() {
  return <ReleasesPage title="Releases" subtitle="Every version of Summit Operations, with what it changed and who it was for." />;
}

export const aboutRoutes: AreaRoute[] = [];

